export function isGoogleAdsOAuthReconnectError(error) {
    const serializedError = typeof error === 'string' ? error : JSON.stringify(error) ?? '';

    return /invalid_grant|token has been expired|token has been revoked|Google OAuth authorization expired or was revoked/i.test(serializedError);
}

export function isGoogleAdsOAuthReconnectRequired(integration) {
    return !integration?.authorizationSuccessful
        || (integration?.errors ?? []).some(isGoogleAdsOAuthReconnectError);
}
